export enum NotificationQueryKeys {
  Primary = "notifications/",
  UnseenCount = "notifications/unseen-count",
  GetNotificationsPaginated = "notifications/get-notifications/paginated",
}
